import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { OrganizationsPage } from '~/components/admin/organizations-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/organizations/')({
  validateSearch: z.object({
    q: z.string().max(100).catch('').default(''),
    page: z.number().int().min(0).catch(0).default(0),
  }),
  head: () => ({ meta: [{ title: `${m.admin_nav_organizations()} – ${m.app_name()}` }] }),
  component: OrganizationsRoute,
})

function OrganizationsRoute() {
  const { q, page } = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_nav_organizations()} />
      <OrganizationsPage q={q} page={page} />
    </>
  )
}
